import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/experiences", label: "Experiences" },
  { to: "/society", label: "Society" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/apply", label: "Apply" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <>
      <nav
        className={`top-nav ${scrolled ? "scrolled" : ""}`}
        data-testid="top-nav"
      >
        <Link to="/" className="brand-mark" data-testid="brand-mark">SAVIAR</Link>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              style={{ opacity: loc.pathname === l.to ? 1 : 0.75 }}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/login"
            data-testid="nav-login"
            style={{ color: "var(--gold-light)" }}
          >
            Member Login
          </Link>
        </div>
        <button
          className="md:hidden text-ivory"
          onClick={() => setOpen(true)}
          data-testid="nav-hamburger"
          aria-label="Open menu"
          style={{ color: "var(--ivory)", background: "transparent", border: "none" }}
        >
          <Menu size={22} />
        </button>
      </nav>

      {open && (
        <div
          className="fixed inset-0 z-[60] flex flex-col items-center justify-center gap-8"
          style={{ background: "var(--black)" }}
          data-testid="mobile-menu"
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-6 right-6"
            style={{ color: "var(--ivory)", background: "transparent", border: "none" }}
            data-testid="mobile-menu-close"
          >
            <X size={24} />
          </button>
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              style={{
                color: "var(--ivory)",
                fontFamily: "var(--serif)",
                fontSize: "1.8rem",
                fontWeight: 300,
                textDecoration: "none",
              }}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/login"
            data-testid="mobile-nav-login"
            style={{
              color: "var(--gold-light)",
              fontFamily: "var(--sans)",
              fontSize: "0.72rem",
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              marginTop: 24,
            }}
          >
            Member Login
          </Link>
        </div>
      )}
    </>
  );
}
